
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const shippinglabelApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listShippingLabels: builder.query ({
      query: (params) => `v2/shippinglabel/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["ShippingLabel"]
    }),
    getShippingLabel: builder.query ({
      query: (shippinglabel_id) => `v2/shippinglabel/${shippinglabel_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["ShippingLabel"]
    }),
    getShippingLabelContents: builder.query ({
      query: (shippinglabel_id) => `v2/shippinglabelcontents/?shipping_label=${shippinglabel_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["ShippingLabelContents"]
    }),
    updateShippingLabel: builder.mutation ({
      query: ({shippinglabel_id, data}) => ({
        url: `v2/shippinglabel/${shippinglabel_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["ShippingLabel"]
    }),
    deleteShippingLabel: builder.mutation ({
      query: (shippinglabel_id) => ({
        url: `v2/shippinglabel/${shippinglabel_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["ShippingLabel"]
    }),
    createShippingLabel: builder.mutation ({
      query: (data) => ({
        url: `v2/shippinglabel/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["ShippingLabel"]
    }),
  })
})


export const {
  useListShippingLabelsQuery,
  useLazyListShippingLabelsQuery,
  useGetShippingLabelQuery,
  useLazyGetShippingLabelQuery,
  useGetShippingLabelContentsQuery,
  useUpdateShippingLabelMutation,
  useDeleteShippingLabelMutation,
  useCreateShippingLabelMutation
} = shippinglabelApi
